import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { getTokens } from 'services/auth'
import { errorMessage } from 'services/messager'
import Loader from 'components/loader'
import { LoaderContainer } from './components/shared.styles'
import { useDispatch } from 'react-redux'
import { clearSession } from 'states/modules/session'

const AuthCallback = () => {
	const dispatch = useDispatch()

	const history = useHistory()
	const searchParams = new URLSearchParams(window.location.search)
	const code = searchParams.get('code')
	const companyId = searchParams.get('state') ?? 12

	const handleAuth = useCallback(async (code, companyId) => {
		try {
			const data = await getTokens(code, companyId)
			localStorage.setItem('user-contracts', JSON.stringify(data))
			dispatch(clearSession())
			history.push('/')
		} catch (e) {
			console.log(e)
			errorMessage({
				content:
					'Não foi possível autenticar o usuário. Tente novamente mais tarde.',
			})
			history.replace('/sign-in')
		}
	}, [])

	useEffect(() => {
		if (code && companyId) {
			handleAuth(code, companyId)
		}
	}, [code, companyId])

	return (
		<LoaderContainer>
			<Loader />
			<p>Aguarde um instante, estamos autenticando você...</p>
		</LoaderContainer>
	)
}

export default AuthCallback
